import gql from "graphql-tag";

export const MY_CAFETERIA_GET_CURRENT_STATEMENT = gql`
  query getCurrentCafeteriaStatement($contractCode: String!) {
    getCurrentCafeteriaStatement(contractCode: $contractCode) {
      _id
      contractCode
      allAmount
      allBenefits
      allCosts
      availableAmount
      state
      startDate
      endDate
    }
  }
`;

export default MY_CAFETERIA_GET_CURRENT_STATEMENT;
